module.exports = __webpack_public_path__ + "static/scale-model-of-mary-todd-lincoln-house-in-lexington-kentucky-5d35bb8ecad5c91275d05d86cce15e7b.png";